import React from 'react';
import { useTranslation } from '../i18n/I18nContext';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ className = '', variant = 'default' }) {
  const { lang, setLang, t } = useTranslation();

  const baseClasses = variant === 'dark' 
    ? 'bg-slate-800/50 text-white border-slate-600 focus:border-slate-400'
    : 'bg-white text-gray-700 border-gray-300 focus:border-blue-500';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Globe className={`h-4 w-4 ${variant === 'dark' ? 'text-slate-400' : 'text-gray-400'}`} />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className={`text-sm rounded-md px-2 py-1 border cursor-pointer focus:outline-none focus:ring-1 ${baseClasses}`}
        aria-label={t('language_label')}
      >
        <option value="nl">NL</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}
